import cx from 'classnames';
import Image from 'next/image';
import Link from 'next/link';

import LogoImage from './logo.svg';

interface LogoProps {
  white?: boolean;
  className?: string;
}

export const Logo: React.FC<LogoProps> = ({ white = false, className }) => (
  <Link href="/" aria-label="Home">
    <Image
      src={LogoImage}
      alt="HealthPlans of North Carolina"
      className={cx(
        {
          'brightness-0 invert': white,
        },
        className,
      )}
    />
  </Link>
);
